<script>
	import { Col, Row, Button } from "sveltestrap";

	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import NoData from "../../../../components/NoDataPage/NoData.svelte";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faPenToSquare as fasPenToSquare } from "@fortawesome/free-solid-svg-icons";
	import { errorMessage, DynamicComponent } from "../../../../store/store";
	import "@splidejs/svelte-splide/css";
	import Exterior from "./PendingIssueTabs/Exterior.svelte";
	import Drive from "./PendingIssueTabs/Drive.svelte";
	import Tabs from "../../../../components/Tabs/Tabs.svelte";
	import { navigate } from "svelte-routing";

	library.add(fasPenToSquare);

	export let issues = [];
	export let img_url = [];
	export let fetchIssue;

	const handleClick = () => {
		DynamicComponent.set(2);
	};

	// Do not change readonly options later, such as `type`, `preloadPages`, etc.
	const options = {
		rewind: true,
		perPage: 2,
		gap: "1px",
		autoWidth: true,
		height: "15rem",
		arrows: img_url.length <= 2 ? false : true,
		// breakpoints: {
		// 	1000: {
		// 		perPage: 1,
		// 	},
		// 	1200: {
		// 		perPage: 2,
		// 	},
		// },
	};

	let items = [
		{
			label: "Drive",
			value: 1,
			component: Drive,
		},
		{
			label: "Exterior",
			value: 2,
			component: Exterior,
		},
	];

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			{#if !issues}
				<NoData />
			{:else}
				<ErrorMessageHandler message={err} />

				<Col>
					<Row class="carousel-detail ">
						<Col xs={12} class="mt-4 px-2">
							<Col
								xs={12}
								class="d-flex justify-content-between px-2 "
							>
								<div class="me-2">
									<p
										class="status-bar-info-2 status-bar-info-issue"
									>
										Pending Approval
									</p>
								</div>
								<div>
									<!-- svelte-ignore a11y-click-events-have-key-events -->
									<p
										class="link"
										on:click={() => handleClick()}
									>
										<i>
											<FontAwesomeIcon
												icon={fasPenToSquare}
											/>
										</i>
										Edit

										<!-- <SwitchComponent
												bind:this={Switch}
											/> -->
									</p>
								</div>
							</Col>
							<Col
								xs={12}
								class="d-flex justify-content-start px-2"
							>
								<div class="mx-0">
									<h4 class="link-hover">
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<b
											class="link-text-hover"
											on:click={() =>
												navigate(
													`/car-management/details/${issues.vehicleId}`
												)}
										>
											{issues.vehicleMake +
												" " +
												issues.vehicleModel +
												" " +
												issues.vehicleNumber}
										</b>
									</h4>
								</div>
							</Col>
							<Col
								xs={6}
								class="d-flex justify-content-start px-2"
							>
								<div class="me-2">
									<p
										class="status-bar-info status-bar-info-1"
									>
										Color: {issues.vehicleColor}
									</p>
								</div>
								<!-- <div>
										<p
											class="status-bar-info status-bar-info-1"
										>
											Issue ID: {issues.issueId}
										</p>
									</div> -->
							</Col>
						</Col>
						<Tabs
							compareMode={true}
							{items}
							{options}
							{img_url}
							{issues}
							{fetchIssue}
							activeTab={issues.reportSection == "Exterior"
								? 2
								: 1}
						/>
					</Row>
				</Col>
			{/if}
		</div>
	</Col>
</Row>

<style>
	:global(.carousel-detail) {
		border: 0.5px solid gray;
		margin-left: 0px !important;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5);
	}

	.link:hover {
		text-decoration: underline;
		filter: brightness(30%);
	}
</style>
